/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

/* eslint-disable no-duplicate-imports */
import { IComponentProps } from '@msdyn365-commerce/core';
import React from 'react';

// @ts-ignore
import { BusinessPartner, BusinessPartnersDataActions } from '@msdyn365-commerce/retail-proxy';
import { IEveBusinessPartnersResources } from '../eve-business-partners.props.autogenerated';
import { DataGrid, IDataGridColumn } from './data-grid';

/**
 * Props of IBusinessPartnersTable.
 */
export interface IBusinessPartnersTableProps extends IComponentProps {
    className: string;
    pageSize?: number;
    resources: IEveBusinessPartnersResources;
    onSelect(businessPartner: BusinessPartner): void;
    hasSearchText: boolean;
    noUsersFound: boolean;
}

/**
 * BusinessPartnersTable component.
 */
export class BusinessPartnersTable extends React.Component<IBusinessPartnersTableProps> {
    public shouldComponentUpdate(nextProps: Readonly<IBusinessPartnersTableProps>): boolean {
        return this.props.id !== nextProps.id;
    }

    public render(): JSX.Element {
        if (this.props.hasSearchText) {
            return <p>{this.props.resources.searchForAccountMessage}</p>;
        } else if (this.props.noUsersFound) {
            return <p>{this.props.resources.noUsersFoundErrorMessage}</p>;
        }
        return (
            <DataGrid
                {...this.props}
                loadData={this.getBusinessPartners}
                columns={this.getColumns()}
                defaultSorting={{ fieldName: 'Name', ascending: true }}
                searchPlaceholderLabel={this.props.resources.businessPartnerSearchCompany}
            />
        );
    }

    /**
     * Get column definition of the table.
     * @returns - Columns.
     */
    private readonly getColumns = (): IDataGridColumn<BusinessPartner>[] => {
        return [
            {
                reactKey: 'name',
                name: this.props.resources.businessPartnerName,
                isSearchable: true,
                onClick: this.props.onSelect,
                onRender: (data: BusinessPartner) => <a role='button'>{data.Name}</a>
            }
        ];
    };

    /**
     * Call retail proxy to get business partners.
     * @returns - Business partners.
     */
    private readonly getBusinessPartners = async () => {
        return [];
        // const businessPartners = await BusinessPartnersDataActions.getManagedBusinessPartnersAsync({
        //     callerContext: this.props.context.actionContext,
        //     bypassCache: 'get',
        //     queryResultSettings: {}
        // });
        // return businessPartners;
    };
}
